import { TextAreaRhf } from '@xemplo/text-area';

import { TestIds } from './payrun-prepare-test.helper';

export const ModalBody = () => {
  return (
    <TextAreaRhf
      aria-label="payrun prepare notes"
      name="notes"
      placeholder="Please enter your notes (Optional)"
      rows={5}
      data-testid={TestIds.PayrunNotes}
    />
  );
};
